var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", [
    _c("legend", [_vm._t("title")], 2),
    _vm._v(" "),
    _c("div", {}, [_vm._t("body")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }